import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#24582A',
      dark: '#17371A',
      contrastText: '#FFFAF1',
    },

    background: {
      default: '#FFFAF1',
      paper: '#D4E9CF',
    },

    text: {
      primary: '#052812',
      secondary: '#17371A',
    },

    neutral: {
      main: '#D4E9CF',
      dark: '#17371A',
    },

    section: {
      bg: '#D4E9CF',
      border: '#24582A',
    },

    filter: {
      bg: '#D4E9CF',
      bgSelected: '#FFFAF1',
      border: '#24582A',
      borderSelected: '#17371A',
    },
  },

  typography: {
    fontFamily:
      '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',

    h1: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
    h2: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
    h3: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
    h4: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
    h5: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
    h6: { fontFamily: '"Fraunces", serif', fontWeight: 120 },
  },

  shape: {
    borderRadius: 8,
  },

  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#17371A',
          color: '#FFFAF1',
          fontSize: '0.75rem',
          fontFamily:
            '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
        },
        arrow: {
          color: '#17371A',
        },
      },
    },

    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#D4E9CF',

          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #D4E9CF inset',
            WebkitTextFillColor: '#052812',
            caretColor: '#052812',
            borderRadius: 8,
          },

          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#24582A',
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#17371A',
          },

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#17371A',
            borderWidth: 2,
          },
        },

        input: {
          color: '#052812',
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#17371A',

          '&.Mui-focused': {
            color: '#17371A',
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily:
            '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
          borderRadius: 8,
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#24582A',
          '&.Mui-checked': {
            color: '#17371A',
          },
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
          backgroundColor: '#FFFAF1',
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#052812',

          '&.Mui-selected': {
            backgroundColor: '#D4E9CF',
          },

          '&.Mui-selected:hover': {
            backgroundColor: '#D4E9CF',
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#24582A',
          borderRadius: 8,
        },

        select: {
          color: '#FFFAF1',
        },

        icon: {
          color: '#FFFAF1',
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFAF1',
        },
      },
    },
  },
});

export default theme;